<template>
  <div class="service-assurance">
    <div class="service-header">
      <div class="header-title"></div>
      <div class="header-subtitle">1V1服务 · 退款保障 · 正规发票 </div>
    </div>
    <div class="service-content">
      <div class="refund-info">
        <div class="refund-left">
          <img class="icon-refund" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/product/product/product-detail/service-assurance/icon-refund.png" alt="">
          <div class="refund-title">退款保证</div>
        </div>
        <div class="refund-right">
          <div class="first-row">订单预审前可全额退款</div>
          <div class="second-row">
            请放心预订
            <img class="icon-query" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/product/product/product-detail/icon-query.png" alt="">
          </div>
        </div>
      </div>

      <div class="hover-detail-info">
        <div class="detail-info-item" v-for="(item, index) in infoList" :key="index">
          <div class="info-title">{{item.title}}</div>
          <div class="info-desc">{{item.desc}}</div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      infoList: [
        {
          title: '1v1服务',
          desc: '资深签证专家一对一指导，涵盖材料准备、资料审核、面试辅导等关键环节，实时答疑，确保材料合规、精准，显著降低拒签风险。',
        },
        {
          title: '退款保障',
          desc: '常规国家签证订单在预审前，支持无理由全额退款，资金可随时提现，零顾虑下单。',
        },
        {
          title: '正规发票',
          desc: '签证费用已含税，提供正规增值税发票。',
        },
      ],
    };
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.service-assurance{
  position: absolute;
  right: 0;
  top: 0;
  width: 242px;
  border-radius: 2px;
  border: 1px solid #E8D9C0;
  line-height: 1;
  z-index: 2;
  background-color: #fff;
  .service-header{
    padding: 10px 12px 8px 12px;
    background: linear-gradient( 135deg, #E8CEB4 0%, #F3E7D1 10%, #FFF6EB 37%, #F4E5D0 58%, #D6BA96 100%);
    border-bottom: 1px solid #E8D9C0;;
    .header-title{
      background: url(https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/product/product/product-detail/service-assurance/service-title-2.png) no-repeat center / 100% 100%;
      width: 83px;
      height: 16px;
    }
    .header-subtitle{
      font-size: 12px;
      color: #2F333D;
      margin-top: 6px;
    }
  }
  .service-content{
    position: relative;
    .refund-info{
      padding: 8px 0;
      display: flex;
      align-items: center;
      .refund-left{
        flex-shrink: 0;
        width: 88px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        &::before{
          content: "";
          width: 1px;
          height: 32px;
          background:  #EEDABE;
          opacity: 0.5;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        .icon-refund{
          width: 28px;
          height: 28px;
        }
        .refund-title{
          color: rgba(24, 12, 7, 0.45);
          font-size: 12px;
          line-height: 17px;
        }
      }
      .refund-right{
        padding-left: 12px;
        color: #5F666E;
        font-size: 12px;
        .second-row{
          display: flex;
          align-items: center;
          margin-top: 6px;
          .icon-query{
            width: 12px;
            height: 12px;
            margin-left: 4px;
          }
        }
      }
    }

    .hover-detail-info{
      display: none;
      width: 100%;
      padding: 20px 12px;
      .detail-info-item{
        margin-bottom: 20px;
        &:last-child{
          margin-bottom: 0;
        }
        .info-title{
          color: #2F333D;
          font-size: 12px;
          line-height: 17px;
          font-weight: 600;
        }
        .info-desc{
          color: #5F666E;
          font-size: 12px;
          line-height: 17px;
          margin-top: 4px;
        }
      }
    }
  }
  &:hover{
    box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.1);
    .service-content{
      .refund-info{
        display: none;
      }
      .hover-detail-info{
        display: block;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/visa-top-infos-components/service-assurance.vue